const E = {
  'Back to Payment Summary': 'Back to Payment Summary',
  '*required fields': '*required fields',
  'Customer details': 'Customer details',
  'Card Holder Name': 'Card Holder Name',
  'Street Number': 'Street Number',
  'Street Name': 'Street Name',
  'Postal Code': 'Postal Code',
  'Payment details': 'Payment details',
  'Transaction Amount': 'Transaction Amount',
  'Order ID': 'Order ID',
  iframeText: 'Please complete the following details exactly as they appear on your card. Do not put spaces or hyphens in the card number.',
  disclaimer: 'Click ‘Process Transaction’ to charge your card. Only click the button once. Using the ‘Back’, ‘Refresh’ or ‘Cancel’ button after you press ‘Process Transaction’ button will not stop the transaction from being processed and may result in a double charge.',
  'Cancel Transaction': 'Cancel Transaction',
  'Process Transaction': 'Process Transaction',
  'No Invoices are selected!': 'No valid payment request found for this payment.',
  CardNumber: 'Card Number*',
  ExpiryDate: 'Expiry Date (MMYY)*',
  CVD: 'CVD*',
  Congratulations: 'Your payment has been approved.',
  Confirmation: 'Confirmation',
  'Amount Remaining': 'Amount Remaining',
  'Invoice #': 'Invoice #',
  'Company Name': 'Company Name',
  'PO #': 'PO #',
  'Balance Due': 'Balance Due',
  'Invoice Payment': 'Invoice Payment',
  PaymentRequest: 'Payment Request',
  PaymentTaxFee: 'Please note a convenience fee of 3% may be added to payments that are more than $1500.00',

  940: 'Please contact Bureau Veritas Technical team for help.',
  941: 'Something went wrong, please try again.',
  942: 'Something went wrong, please try again.',
  943: 'Invalid Card Number, Please check your Card Number and try again.',
  944: 'Invalid Expiry Date, Please check your Card Expiry date and try again.',
  945: 'Invalid CVD code, Please check your CVD code and try again.',

  'Prepaid Request#': 'Prepaid Request #',
  'Submission#': 'Submission #',
  'Payment Amount': 'Payment Amount',
  OrderInfo: 'Order ID: {{OrderId}}',
  OKMessage: 'A payment receipt will be emailed to the invoice attention.',  
  DeclinePaymentMessage: 'Payment Transaction has been declined',
  ApprovedMessage: 'On the following page, you can print a copy of the payment confirmation for your records.',
  LinkExpire: 'This payment link is no longer valid. Please check your email for a newer link, or contact your Bureau Veritas representative for assistance.',
  InvoiceIsPaid: 'This invoice has been paid, so no additional payment is required. Please Contact your Bureau Veritas representative if assistance is required.',
  ContactBVPM:'Please Contact your Bureau Veritas representative if assistance is required.',
};

const F = {
  940: "Veuillez contacter l'équipe technique de Bureau Veritas pour obtenir de l'aide.",
  941: "Une erreur s'est produite. Veuillez réessayer.",
  942: "Une erreur s'est produite. Veuillez réessayer.",
  943: 'Numéro de carte invalide, veuillez vérifier votre numéro de carte et réessayer.',
  944: "Date d'expiration non valide. Vérifiez la date d'expiration de votre carte et réessayez.",
  945: 'Code CVD invalide, vérifiez votre code CVD et réessayez.',

  PaymentTaxFee: 'Prendre note que des frais de commodité de 3 % pourraient s’appliquer aux paiements de plus de 1 500 $',
  PaymentRequest: 'Demande de paiement',
  'Amount Remaining': 'Quantité restante',
  'Back to Payment Summary': 'Revenir au résumé de paiement',
  '*required fields': '*champs obligatoires',
  'Customer details': 'Information sur le client',
  'Card Holder Name': 'Détenteur de la carte',
  'Street Number': 'Numéro civique',
  'Street Name': 'Nom de rue',
  'Postal Code': 'Code postal',
  'Payment details': 'Détails du paiement',
  'Transaction Amount': 'Montant de la transaction',
  'Order ID': 'No de commande',
  iframeText: 'Inscrire les renseignements suivants tels qu\'indiqués sur votre carte. Entrez le numéro sans  espace et trait d\'union.',
  disclaimer: "Cliquez sur Traiter la transaction pour débiter votre carte. Cliquez sur le bouton qu'une seule fois. La transaction sera effectuée même si vous cliquez sur Retour, Rafraîchir ou Annuler et pourrait même être traitée en double.",
  'Cancel Transaction': 'Annuler la transaction',
  'Process Transaction': 'Traiter la transaction',
  'No Invoices are selected!': 'Aucune demande de paiement valide trouvée pour ce paiement.',
  CardNumber: 'No de la carte*',
  ExpiryDate: 'Date d expiration (MM AA)*',
  CVD: 'CVV*',
  Congratulations: 'Votre paiement a été approuvé.',
  'Invoice #': 'No de facture',
  Confirmation: 'Confirmation',
  'Company Name': 'Nom de l\'entreprise',
  'PO #': 'No de PO',
  'Balance Due': 'Solde dû',
  'Invoice Payment': 'Paiement de facture',
  'Prepaid Request#': 'Numéro de demande Prépayé',
  'Submission#': 'Soumission #',
  'Payment Amount': 'Montant du paiement',
  OrderInfo: 'Numéro de commande: {{OrderId}}',
  OKMessage: 'Un reçu de paiement sera envoyé par email à l`attention de la facture.',   
  DeclinePaymentMessage: 'La transaction de paiement a été refusée',
  ApprovedMessage: 'Sur la page suivante, vous pouvez imprimer une copie de la confirmation de paiement pour vos dossiers.',
  LinkExpire: "Ce lien de paiement n'est plus valide. Veuillez vérifier votre courrier électronique pour obtenir un lien plus récent ou contacter votre représentant Bureau Veritas pour obtenir de l'aide.",
  InvoiceIsPaid: "Cette facture a été payée, aucun paiement supplémentaire n'est donc requis. Veuillez contacter votre représentant Bureau Veritas si une assistance est nécessaire.",
  ContactBVPM: 'Veuillez contacter votre représentant Bureau Veritas si une assistance est nécessaire.'
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/invoicesPaymentDetails.js